import React, { ReactNode } from 'react';
import { Form } from 'antd';
import { FormProps as FormCopyProps } from 'antd/lib/form';

export const useForm = Form.useForm;
export const List = Form.List;
export type FormProps = FormCopyProps & {
  children?: ReactNode;
};

const ProForm: React.FC<FormProps> = React.forwardRef<any, FormProps>(
  (props, ref) => {
    const { children, ...resProps } = props;
    return (
      <Form ref={ref} {...resProps}>
        {children}
      </Form>
    );
  },
);

export default ProForm;
